import {
  type GenerationTool,
  getToolChannel,
  isCustomMultiPromptTool,
} from 'src/data/generationTool';
import {
  getMultiPromptTemplateBlockTypes,
  type MultiPromptTemplate,
  type TemplateChannelTool,
} from 'src/data/template';

type BranchTemplate = Pick<MultiPromptTemplate, 'blocks'> & { generationTool: GenerationTool };

/**
 * The tools a template writes with. A campaign's own tool declares no channel, so it is its blocks
 * that place it in the tree — under every platform it writes for, rather than under none of them.
 */
export const getTemplateChannelTools = (template: BranchTemplate): TemplateChannelTool[] => {
  const tools = isCustomMultiPromptTool(template.generationTool)
    ? getMultiPromptTemplateBlockTypes(template)
    : [template.generationTool];

  return tools.map((generationTool) => ({
    generationTool,
    channel: getToolChannel(generationTool),
  }));
};
